import React from "react";
import styles from "./additionalfeedback.module.css";

const AdditionalFeedback = ({
  textFieldValue,
  setTextFieldValue,
}: {
  textFieldValue: string;
  setTextFieldValue: (value: string) => void;
}) => {
  return (
    <div className={styles.additionalFeedbackParent}>
      <span className={styles.afHeader}>Additional Feedback:</span>
      <textarea
        className={styles.afTextfieldParent}
        rows={2}
        placeholder="please provide additional feedback"
        maxLength={3000}
        onChange={(e) => setTextFieldValue(e.target.value)}
        value={textFieldValue}
      ></textarea>
    </div>
  );
};

export default AdditionalFeedback;
